module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24
    }
  }, [_c('h3', [_vm._v("Average Rental")]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "data": _vm.chart,
      "donut": true,
      "thousands": ",",
      "legend": "right",
      "download": true,
      "colors": _vm.colours
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24
    }
  }, [_c('h3', [_vm._v("Total Sites")]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "data": _vm.chart2,
      "donut": true,
      "thousands": ",",
      "legend": "left",
      "colors": _vm.colours,
      "download": true
    }
  })], 1)], 1), _vm._v(" "), (_vm.showDetails) ? _c('div', [_c('hr'), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.landowners,
      "border": "",
      "stripe": "",
      "show-summary": "",
      "summary-method": _vm.summaryFormatter
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "owner",
      "width": "400",
      "label": "Owner"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sites",
      "label": "Sites",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatInt
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalDeposit",
      "label": "Total Deposit",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "avgValue",
      "label": "Avg. Rental",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08d8ab60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/charts/PropertyCharts.vue
// module id = 1404
// module chunks = 0